import { module } from 'angular';
import { eventOnloadDirective } from './event-onload.directive';

export const EventOnloadModule = module('app.directives.event-onload', [])
  .directive('eventOnload', eventOnloadDirective)
  .name;



// WEBPACK FOOTER //
// ./app/shared/directives/event-onload/event-onload.module.ts